import { AUTH_ROUTE } from './constants';
import { AuthResponseBody } from './types';

async function authenticate() {
  const response = await fetch(AUTH_ROUTE);

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const { uuid } = (await response.json()) as AuthResponseBody;

  return uuid;
}

export default authenticate;
